/**
 * Config: Timings
 * -----------------------------------------------------------------------------
 * Global configuration for consistent values for timing durations.
 * - Automatically generated by `design` command, do not edit.
 *
 */
// eslint-disable

export const values = {
  quick: 0.1,
  normal: 0.3,
  slow: 0.6,
  loading: 2,
  message: 3,
}

export default {
  quick: values.quick * 1000,
  normal: values.normal * 1000,
  slow: values.slow * 1000,
  loading: values.loading * 1000,
  message: values.message * 1000,
}
